<!--
 * @Description: 居民一户一表改造
--> 
<template>
  <div class="meter-transfer-form">
    <van-nav-bar
      left-text="返回"
      :title="$route.meta.title"
      @click-left="$comm.onClickLeft"
      left-arrow
      fixed
      >
      <template #left>
        <span class="iconfont iconshang comm-rotate-270"></span>
        <span class="comm-return">返回</span>
      </template>
    </van-nav-bar>
    <div class="comm-topbar-height" v-show="$comm.titleShow()"></div>
    <van-form @submit="onSubmit">
      <!-- <van-field
        required
        v-model="form.busson"
        label="流程编号"
        placeholder="流程编号"
        :rules="[{ required: true, message: '请输入流程编号' }]"
      /> -->
      <van-field
        required
        v-model="form.usernosum"
        label="总表用户号"
        placeholder="总表用户号"
        :rules="[{ required: true, message: '请输入总表用户号' }]"
        @change="getUserInfo"
      />
      <van-field
        required
        v-model="form.fixaddrsum"
        label="总表地址"
        placeholder="总表地址"
        :rules="[{ required: true, message: '总表地址' }]"
      />
      <van-field
        required
        v-model="form.uname"
        label="新户户主名称"
        placeholder="新户户主名称"
        @change="nameChange()"
        :rules="[{ required: true, message: '新户户主名称' }]"
      />
      <van-field
        required
        v-model="form.idenno"
        label="身份证号"
        placeholder="身份证号"
        :rules="[{ pattern: $patternId, message: '请输入正确格式' }]"
      />
      <van-field
        required
        v-model="form.addr"
        label="用户地址"
        placeholder="用户地址"
        :rules="[{ required: true, message: '请输入用户地址' }]"
      />
      <van-field
        required
        v-model="form.fixaddr"
        label="安装地址"
        placeholder="安装地址"
        :rules="[{ required: true, message: '请输入安装地址' }]"
      />
      <van-field
        v-model="form.tel"
        label="新固定电话"
        placeholder="新固定电话"
      />
      <van-field
        required
        v-model="form.mobile"
        label="新手机号码"
        placeholder="新手机号码"
        :rules="[{ pattern: $pattern, message: '请输入正确格式' }]"
      />
      <van-field
        required
        :rules="[{ required: true, message: '请输入联系人' }]"
        v-model="form.operator"
        name="联系人"
        label="联系人"
        @change="nameChange()"
        placeholder="联系人"
      />
      <van-field
        required
        v-model="form.opmobile"
        name="validator"
        label="联系人手机"
        placeholder="联系人手机"
        :rules="[{ pattern: $pattern, message: '请输入正确格式' }]"
      />
      <van-field
        v-model="form.opidenno"
        label="联系人身份证"
        placeholder="联系人身份证"
        :rules="[{ validator: $comm.validatorId, message: '请输入正确格式' }]"
      />
      <van-field
        v-model="form.remark"
        rows="2"
        autosize
        label="备注"
        type="textarea"
        maxlength="500"
        placeholder="请输入留言"
        show-word-limit
      />
      <div class="comm-form-group">证件资料上传</div>
      <van-field
        name="uploaderMst" 
        label="户主身份证"
        :required="!isNameSame"
        :rules="[{ 
          required: !isNameSame, 
          message: $idcardmsg
        }]"
        >
        <template #input>
          <van-uploader
            :deletable="!$route.query.readonly"
            :show-upload="!$route.query.readonly"
            multiple
            v-model="uploaderMst"
            :after-read="afterReadMaster"
            @delete="onDeleteMaster"
            />
        </template>
      </van-field>
      <van-field required name="uploaderHs" label="房屋产权证">
        <template #input>
          <van-uploader
            :deletable="!$route.query.readonly"
            :show-upload="!$route.query.readonly"
            multiple
            v-model="uploaderHs"
            :after-read="afterReadHourse"
            @delete="onDeleteHourse"
            />
        </template>
      </van-field>
      <van-field required name="uploaderOpt" label="联系人身份证">
        <template #input>
          <van-uploader
            :deletable="!$route.query.readonly"
            :show-upload="!$route.query.readonly"
            multiple
            v-model="uploaderOpt"
            :after-read="afterReadOpt"
            @delete="onDeleteOpt"
            />
        </template>
      </van-field>
      <van-field
        v-if="!$route.query.readonly"
        required
        v-model="form.smscode"
        label="验证码"
        placeholder="请输入验证码"
        :rules="[{ required: true, message: '请输入验证码' }]"
      >
        <template #button>
          <sms-btn :phone="form.opmobile"></sms-btn>
        </template>
      </van-field>
      <div v-if="!$route.query.readonly" style="margin:17px 16px;margin-bottom:36.5px;">
        <van-button
          type="info"
          color="#1677FF"
          size="large"
          style="height:44px;"
          native-type="submit"
          >
          确认提交
        </van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import smsBtn from '@/components/smsBtn.vue'
export default {
  name: 'RemodelForm',
  components: {
    smsBtn
  },
  data() {
    let cuser_info = null
    if(localStorage.getItem('cuser_info')){
      cuser_info = JSON.parse(localStorage.getItem('cuser_info'))
    }
    return {
      popShow: false,
      // masterUrls: [{ url: 'https://img.yzcdn.cn/vant/leaf.jpg' }],
      uploaderMst: [], // vant自带缩略图站位
      uploaderHs: [],
      uploaderOpt: [],
      masterUrls: [],
      hourseUrls: [],
      optUrls: [],
      message: '',
      radio: '1',
      form: {
        busson:'', // 受理编号
        usernosum:'', // 总表用户编号
        fixaddrsum:'', // 总表地址
        uname: '',
        idenno: '',
        addr: '', // 用户地址
        fixaddr: '', // 装表地址
        tel: '',
        mobile: '',
        smscode: '',
        operator: cuser_info?cuser_info.uname:'',
        opmobile: cuser_info?cuser_info.mobile:'',
        opidenno: '',
        remark: '',
        attach: []
      },
      isNameSame:false
    }
  },
  mounted() {
    if(this.$route.query.busscode&&this.$route.query.bussno){
      this.$comm.getBussInfo(this.$route.query.busscode, this.$route.query.bussno).then(res => {
        this.form = res
        let result = this.$comm.analysisAttach(res)
        this.uploaderMst = result.uploaderMst
        this.uploaderHs = result.uploaderHs
        this.uploaderOpt = result.uploaderOpt
        this.masterUrls = result.masterUrls
        this.hourseUrls = result.hourseUrls
        this.optUrls = result.optUrls
      })
    }
  },
  beforeRouteLeave (to, from, next) {
    if (to.name === 'BusinessProgress') {
      to.meta.isUseCache = true
    }
    next()
  },
  methods: {
    nameChange(){
      if(this.form.uname===this.form.operator){
        this.isNameSame = true
      }else{
        this.isNameSame = false
      }
    },
    afterReadMaster (file) {
      this.$loading('上传中...')
      this.$http.post(this.$api.fileUpload, {
        fileext: this.$comm.extname(file.file.name),
        base64: file.content
      }).then(res => {
        this.$clear()
        if (res.code === '000') {
          this.masterUrls.push(res.data)
        } else {
          this.$toast('上传失败')
        }
      })
    },
    afterReadHourse (file) {
      this.$loading('上传中...')
      this.$http.post(this.$api.fileUpload, {
        fileext: this.$comm.extname(file.file.name),
        base64: file.content
      }).then(res => {
        this.$clear()
        if (res.code === '000') {
          this.hourseUrls.push(res.data)
        } else {
          this.$toast('上传失败')
        }
      })
    },
    afterReadOpt (file) {
      this.$loading('上传中...')
      this.$http.post(this.$api.fileUpload, {
        fileext: this.$comm.extname(file.file.name),
        base64: file.content
      }).then(res => {
        this.$clear()
        if (res.code === '000') {
          this.optUrls.push(res.data)
        } else {
          this.$toast('上传失败')
        }
      })
    },
    onDeleteMaster (file, detail) {
      this.masterUrls.splice(detail.index, 1)
    },
    onDeleteHourse (file, detail) {
      this.hourseUrls.splice(detail.index, 1)
    },
    onDeleteOpt (file, detail) {
      this.optUrls.splice(detail.index, 1)
    },
    onSubmit() {
      this.form.attach = this.$comm.getAttach(this.masterUrls, this.hourseUrls, this.optUrls, [])
      this.$http.post(this.$api.personRemodel, this.form).then(res => {
        if (res.code==='000') {
          this.$router.push({
            path: '/business/success',
            query: {
              title: this.$route.meta.title,
              from: '业务办理'
            }
          })
        } else {
          this.$toast(res.msg)
        }
      })
    },
    getUserInfo(){
      if (this.form.usernosum) {
				this.form.fixaddrsum = "";
				this.$http.post(this.$api.getUserInfo,{
					userno: this.form.usernosum
				}).then(res => {
					this.form.fixaddrsum = res.data.zbwz;
				});
			}
    }
  },
}
</script>

<style lang="less" scoped>
.meter-transfer-form{
  /deep/.van-radio-group.van-radio-group--horizontal{
    font-size:12px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(33,33,33,1);
    .van-radio--horizontal{
      margin-right: 0;
      margin-left: 4px;
      .van-radio__label{
        margin-left: 2px;
      }
    }
  }
  .form-pop{
    width:85%;
    height:60%;
    border-radius:4px;
    font-size:12px;
    .user-list{
      background:rgba(255,255,255,1);
      padding: 21px 16px;
    }
  }
}
</style>